import React from "react";

import DragIcon from "@images/fillInTable/modal-drag-icon.svg";
import XMark from "@images/fillInTable/modal-x-mark.svg";
import { useDragModal } from "@molecules/FillInTableArticleTableModal/hooks/useDragModal";
import { useResizeModal } from "@molecules/FillInTableArticleTableModal/hooks/useResizeModal";

import * as S from "./FillInTableArticleImageModal.style";

import type { ParsedJsonImageContentType } from "@/types/fillInTableContent.types";

interface Props {
  item: ParsedJsonImageContentType;
  closeModal: () => void;
}

const FillInTableArticleImageModal = ({ item, closeModal }: Props) => {
  const { draggedTargetRef, draggedPosition, onMouseDown } = useDragModal();
  const { modalSizeWidth, onMouseDownResize } =
    useResizeModal(draggedTargetRef);

  return (
    <S.FillInTableArticleModalWrapper
      ref={draggedTargetRef}
      draggedPosition={draggedPosition}
      modalSizeWidth={modalSizeWidth}
    >
      <S.FillInTableArticleModalInnerWrapper>
        <S.ResizeBorder
          onMouseDown={(e) => onMouseDownResize(e, "left")}
          isLeftBorder
        />
        <S.FillInTableModalHeadLine onMouseDown={onMouseDown}>
          <S.DragBox>
            <img src={DragIcon} alt="drag-icon" />
            <span>Drag</span>
          </S.DragBox>
          <S.CloseBox onClick={() => closeModal()}>
            <span>Close View</span>
            <img src={XMark} alt="modal-x-mark" />
          </S.CloseBox>
        </S.FillInTableModalHeadLine>
        <S.FillInTableContentContainer>
          <div>
            <img src={item.source} alt="article-img" />
          </div>
        </S.FillInTableContentContainer>
        <S.ResizeBorder onMouseDown={(e) => onMouseDownResize(e, "right")} />
      </S.FillInTableArticleModalInnerWrapper>
    </S.FillInTableArticleModalWrapper>
  );
};

export default FillInTableArticleImageModal;
